import Immutable from 'seamless-immutable';
import _ from 'lodash';
import RelativeAccountModel from './relative-account-model';
import { baseCollection } from '../../common/collections';

/**
 * Transforms and array of backend form objects into an AccountCollection
 * @param {Object[]} accounts - backend formatted accounts
 * @returns {Form[]}
 */
function deserialize(accounts = []) {
  return Immutable(_.map(accounts, RelativeAccountModel.deserialize));
}

/**
 * Transforms a FormCollection into an array of backend account objects
 * @param {Account[]} accounts
 * @returns {Object[]}
 */
function serialize(accounts) {
  return _.map(accounts, (account) => RelativeAccountModel.serialize(account));
}

export default {
  ...baseCollection,
  deserialize,
  serialize,
};
